import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "open-searches-modal-container",
  "data-cy": "advanced-search-open-search-modal"
}
const _hoisted_2 = { class: "open-searches-modal-filter-container" }
const _hoisted_3 = { class: "open-searches-modal-table-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "table with-sticky-header",
  "data-cy": "advanced-search-filtered-table"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "ellipsis" }
const _hoisted_7 = { class: "ellipsis" }
const _hoisted_8 = { class: "ellipsis" }
const _hoisted_9 = {
  key: 1,
  class: "empty-state"
}

import Alert from "@common/components/Alert.vue";
import CommonFilter from "@common/components/CommonFilter.vue";
import { AdvancedSearchEntry } from "@medapro-types/AdvancedSearch/AdvancedSearch";
import _ from "lodash";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

//#region General

type ViewModel = { selectedSearch: AdvancedSearchEntry | null; filter: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenSearches',
  props: {
    value: { type: Boolean },
    searches: {}
  },
  emits: ["input", "confirm"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { d: $d } = useI18n();


//#endregion

//#region Show
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ selectedSearch: null, filter: "" });
//#endregion

//#region Select
const selectSearch = (entry: AdvancedSearchEntry) => {
  vm.selectedSearch = entry;
};
//#endregion

//#region Filter
const filteredSearches = computed<AdvancedSearchEntry[]>(() => {
  let result = props.searches;

  if (vm.filter?.length) result = result.filter((x) => _.includes(x.name.toLowerCase(), vm.filter.toLowerCase()));

  return result;
});
//#endregion

//#region Transform
const getDateTime = (date: string | null | undefined) => {
  return date ? $d(new Date(date), "shortDateTime") : "";
};
//#endregion

//#region Life
const showHandler = () => {
  vm.selectedSearch = null;
};

const confirmhandler = () => {
  localValue.value = false;
  emits("confirm", vm.selectedSearch);
};
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.$t('openSearch'),
    "body-class": "open-searches-modal",
    size: "lg",
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localValue).value = $event)),
    "header-close-content": "",
    onShow: showHandler,
    onOk: confirmhandler
  }, {
    "modal-footer": _withCtx(({ ok, cancel }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        variant: "primary",
        disabled: !vm.selectedSearch,
        "data-cy": "advanced-search-open-search-open-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("Open")), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled"]),
      _createVNode(_component_b_btn, {
        onClick: cancel,
        "data-cy": "advanced-search-open-search-cancel-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("Cancel")), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CommonFilter, {
            modelValue: vm.filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.filter) = $event)),
            placeholder: _ctx.$t('FilterByName'),
            triggerByTime: "",
            "data-cy": "advanced-search-filter"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (filteredSearches.value.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("name")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("UpdatedOn")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("UpdatedBy")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("CreatedOn")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("CreatedBy")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSearches.value, (search) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: search.advancedSearchId,
                      onClick: ($event: any) => (selectSearch(search)),
                      onDblclick: confirmhandler,
                      class: _normalizeClass({ selected: vm.selectedSearch?.advancedSearchId == search.advancedSearchId })
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(search.name), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(getDateTime(search.updatedOn)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(search.updatedBy), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(getDateTime(search.createdOn)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(search.createdBy), 1)
                      ])
                    ], 42, _hoisted_5))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(Alert, {
                  class: "w-100",
                  "with-icon": "",
                  show: "",
                  variant: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("NoSearchesMatchYourFilter")), 1)
                  ]),
                  _: 1
                })
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})